/**
 * Registra /sw.js. Chamado uma vez no boot (index.js).
 * Em dev, registra normalmente — facilita testar push. Para desativar local,
 * setar window.__DISABLE_SW = true antes do bundle carregar.
 */

import { logPwaEvent } from './telemetry';
import { isNative } from '../platform/native';

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (window.__DISABLE_SW) return;
  if (!('serviceWorker' in navigator)) return;

  // No app nativo (Capacitor) o proprio runtime serve os assets locais. Um SW
  // registrado por cima disputa o controle das requests e derruba o cold start
  // em tela branca. Cache offline e update passam a ser responsabilidade do
  // shell nativo (assets empacotados + live update).
  if (isNative()) {
    logPwaEvent('sw-skip-native');
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        logPwaEvent('sw-registered', { scope: reg.scope });

        // Detecta atualizacao do SW e avisa para skipWaiting → ativa imediato.
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              logPwaEvent('sw-update-available');
              sw.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });

        // Forca checagem de update:
        //   - a cada 30 min (aba aberta o dia inteiro)
        //   - toda vez que a aba volta a ficar visivel (mobile PWA)
        // Sem isso, o browser so checa update do sw.js em nova navegacao —
        // usuaria com PWA aberto passa horas com bundle antigo.
        const forceUpdate = () => reg.update().catch(() => {});
        setInterval(forceUpdate, 30 * 60 * 1000);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') forceUpdate();
        });
      })
      .catch((err) => logPwaEvent('sw-register-fail', { msg: err.message }));

    // Quando o SW novo assume o controle, recarrega 1x para pegar bundle novo.
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
